import React from "react";
import styles from "./styles.module.css";
import { sanitizeUrl } from "../sanitize";

const LogosBlock = {
  label: "Logos",
  fields: {
    logos: {
      type: "array",
      getItemSummary: (item, i) => item.alt || `Logo #${i}`,
      defaultItemProps: {
        alt: "",
        imageUrl: "",
      },
      arrayFields: {
        alt: { type: "text" },
        imageUrl: { type: "text" },
      },
    },
  },
  defaultProps: {
    logos: [
      {
        alt: "xbox",
        imageUrl:
          "https://logolook.net/wp-content/uploads/2021/07/Xbox-Logo.png",
      },
      {
        alt: "xbox",
        imageUrl:
          "https://logolook.net/wp-content/uploads/2021/07/Xbox-Logo.png",
      },
      {
        alt: "xbox",
        imageUrl:
          "https://logolook.net/wp-content/uploads/2021/07/Xbox-Logo.png",
      },
      {
        alt: "xbox",
        imageUrl:
          "https://logolook.net/wp-content/uploads/2021/07/Xbox-Logo.png",
      },
      {
        alt: "xbox",
        imageUrl:
          "https://logolook.net/wp-content/uploads/2021/07/Xbox-Logo.png",
      },
    ],
  },
  render: ({ logos }) => {
    return (
      <div className={styles.Logos}>
        <div className={styles["Logos-items"]}>
          {logos.map((item, i) => (
            <div key={i} className={styles["Logos-item"]}>
              <img
                className={styles["Logos-image"]}
                alt={item.alt}
                src={sanitizeUrl(item.imageUrl)}
                height={64}
              />
            </div>
          ))}
        </div>
      </div>
    );
  },
};

export default LogosBlock;